/**
 * Format an integer minor-units amount as a localized currency string.
 * The per-currency exponent (EUR→2, JPY→0, …) is derived from Intl, so the
 * single minor→major division is the only arithmetic and runs once, at format
 * time, on a bounded integer. Never do money math in float elsewhere.
 */
export function formatMinor(
	amountMinor: number,
	currency: string,
	locale = 'it-IT'
) {
	const formatter = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency
	})
	const fractionDigits =
		formatter.resolvedOptions().maximumFractionDigits ?? 2
	return formatter.format(amountMinor / 10 ** fractionDigits)
}

/**
 * An amount in cents as euro, whole when it has no cents, with the thousands
 * always grouped so that two amounts on one screen read the same way:
 * "9.000 €", "15.000 €", "10.000,50 €".
 */
export function formatEuroCents(cents: number, locale = 'it-IT') {
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: 'EUR',
		useGrouping: 'always',
		minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
		maximumFractionDigits: 2
	}).format(cents / 100)
}
